export default "__VITE_ASSET__C$OprSZk__"